import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { CommonService } from '../common/services/common.service';
declare var $: any;

@Component({
  selector: 'app-vacatures',
  templateUrl: './vacatures.component.html',
  styleUrls: ['./vacatures.component.css']
})
export class VacaturesComponent implements OnInit {

  constructor(public _commonService: CommonService) { }
  
  @ViewChild('videoElement',{static: true}) videoElementRef: ElementRef;
  @ViewChild('videoElement1',{static: true}) videoElementRef1: ElementRef;

  

  ngOnInit() {
    sessionStorage.setItem("isUploadValid1","false");
    sessionStorage.setItem("isUploadValid2","false");

    const pageTitle = document.getElementById('page-title') as HTMLInputElement;
    if (pageTitle) {
      pageTitle.innerText = 'ticketvoordeel vacatures';
    }
    
  }
  ngAfterViewInit() {
    // Delay the start of video playback by 5 seconds
    setTimeout(() => {
      
      this.playVideo();
    }, 1000);
  }

  playVideo() {
    const videoElement: HTMLVideoElement = this.videoElementRef.nativeElement;
    videoElement.play();
    const videoElement1: HTMLVideoElement = this.videoElementRef1.nativeElement;
    videoElement1.play();
  }

  externalPrivacy() {
    const privacyPageUrl: string = "https://ticketvoordeel.nl/page/privacy-verklaring";
    const windowFeatures: string = "toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=400,height=600";
    const privacyWindow: Window | null = window.open(privacyPageUrl, "_blank", windowFeatures);

  }

  stageLopen(): void {
    const targetElement = $("#lopenDetails");

    if (targetElement.length > 0) {
      const scrollTopValue = targetElement.offset().top || 0;

      $('html,body').animate({
        scrollTop: scrollTopValue
      }, 'slow');
    }
  }

  gotoForm(): void {
    const targetElement = $("#vacancyFormAdminSection");

    if (targetElement.length > 0) {
      const scrollTopValue = targetElement.offset().top || 0;

      $('html,body').animate({
        scrollTop: scrollTopValue
      }, 'slow');
    }
  }

  triggerUpload(name: string): void {
    if (name === "cv") {
      const fileInput = document.getElementById('upload') as HTMLInputElement;
      fileInput.click();
    } else if (name === "mo") {
      const fileInput = document.getElementById('upload1') as HTMLInputElement;
      fileInput.click();
    }
  }

  uploadFilesResume(name: string): void {
    if (name === "cv") {
      const cvStatus = document.getElementById("cvStatus") as HTMLElement;
      cvStatus.style.color = "red";
      cvStatus.innerHTML = "Uploading";
    } else if (name === "motivatie") {
      const motivatieStatus = document.getElementById("motivatieStatus") as HTMLElement;
      motivatieStatus.style.color = "red";
      motivatieStatus.innerHTML = "Uploading";
    }

    if (sessionStorage.getItem("vacancyId") == null) {
      sessionStorage.setItem("vacancyId", this.generateRandomString(10));
    }

    let fileInput: HTMLInputElement | null = null;
    let file: File | undefined;

    if (name === "cv") {
      fileInput = document.getElementById("upload") as HTMLInputElement;
    } else if (name === "motivatie") {
      fileInput = document.getElementById("upload1") as HTMLInputElement;
    }

    if (fileInput) {
      file = fileInput.files[0];
    }

    if (file) {
      const formData = new FormData();
      formData.append("id", sessionStorage.getItem("vacancyId")!);
      formData.append("name", name);
      formData.append("cv", file);
      $.ajax({
        url:  this._commonService.baseUrl + "submitfilevacancy",
        type: 'POST',
        data: formData,
        processData: false,
        contentType: false,
        success: function (response: any) {
          if (name === "cv") {
            const cvStatus = document.getElementById("cvStatus") as HTMLElement;
            cvStatus.style.color = "green";
            cvStatus.innerHTML = "Uploaded";
            sessionStorage.setItem("isUploadValid1","true");
          } else if (name === "motivatie") {
            const motivatieStatus = document.getElementById("motivatieStatus") as HTMLElement;
            motivatieStatus.style.color = "green";
            motivatieStatus.innerHTML = "Uploaded";
            sessionStorage.setItem("isUploadValid2","true");
          }
        },
        error: function (error: any) {
          // Handle error here
        }
      });
    }
  }

  generateRandomString(length: number): string {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    const charactersLength = characters.length;

    for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * charactersLength);
      result += characters.charAt(randomIndex);
    }

    return result;
  }

  sentDetails() {
    
    const voornaam = $('input[name="voornaam"]').val() as string;
    const achternaam = $('input[name="achternaam"]').val() as string;
    const huisnummer = $('input[name="huisnummer"]').val() as string;
    const postcode = $('input[name="postcode"]').val() as string;
    const stad = $('input[name="stad"]').val() as string;
    const usrnm = $('input[name="usrnm"]').val() as string;
    const telefoonnummer = $('input[name="telefoonnummer"]').val() as string;
    const geboortedatum = $('input[name="Geboortedatum"]').val() as string;

    if (sessionStorage.getItem("isUploadValid1") == 'false' || sessionStorage.getItem("isUploadValid2") == 'false') {
      alert("Alle velden zijn verplicht");
      return;
  } 
    
    $.ajax({
        url: this._commonService.baseUrl + "submitvacancy",
        type: "POST",
        data: {
            Id: sessionStorage.getItem("vacancyId"),
            Voornaam: voornaam,
            Achternaam: achternaam,
            Huisnummer: huisnummer,
            Postcode: postcode,
            Stad: stad,
            Email: usrnm,
            Telefoonnummer: telefoonnummer,
            Geboortedatum: geboortedatum,
        },
        success: function (result: any) {
            alert("Wat leuk dat je bij ons hebt gesolliciteerd. Onze HR afdeling zal binnen 3 werkdagen met je contact opnemen.");
            sessionStorage.removeItem("vacancyId");
            sessionStorage.setItem("isUploadValid1","false");
            sessionStorage.setItem("isUploadValid2","false");
            setTimeout(function () { window.location.reload(); }, 3000);
        },
        error: function (xhr: any, status: string, error: any) {
            sessionStorage.removeItem("vacancyId");
            sessionStorage.setItem("isUploadValid1","false");
            sessionStorage.setItem("isUploadValid2","false");
            setTimeout(function () { window.location.reload(); }, 3000);
        }
    });
  }
  

}
